'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'beer-mug-empty';
var width = 512;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M352 64L64 64l0 384 288 0 0-87.6c0-.2 0-.5 0-.7L352 64zm32 306.5l0 77.5 0 32-32 0L64 480l-32 0 0-32L32 64l0-32 32 0 288 0 32 0 0 32 0 32 112 0 16 0 0 16 0 192 0 10.5-9.6 4.2L384 370.5zM384 128l0 207.5 96-42L480 128l-96 0zm-224 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zm64 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zm64 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;